import Swal, { SweetAlertOptions } from "sweetalert2"
export default {
  install: (Vue: any) => {
    // 4. adicionar um método de instância
    Vue.prototype.$swal = () => {
      return {
        error: (err: any, defau = "Não foi possível carregar dados.") => {
          console.log(err)
          return Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err?.response?.data?.message || err || defau,
          })
        },
        fire: ({
          icon = "error",
          title = "Oops...",
          text = "Something went wrong!",
          ...data
        }: any) => {
          return Swal.fire({ icon, title, text, ...data })
        },
        success: (title = "Operação realizada com sucesso!") => {
          return Swal.fire({
            icon: "success",
            title,
            showConfirmButton: false,
            timer: 1500,
          })
        },
        offline: () => {
          return Swal.fire("Oops...", "Você está sem internet!", "error")
        },
        online: () => {
          return Swal.fire("Oba!", "Conexão foi reestabelecida!", "success")
        },
        confirmation: async (
          text = "Deseja realmente executar essa ação?",
          showCancelButton = true,
          cb: Function
        ) => {
          return await Swal.fire({
            text,
            icon: "warning",
            showCancelButton,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            preConfirm: async () => await cb(),
          })
        },
      }
    }
  },
}
